<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 OS-m Admin — Parte 1: Acesso (Login e Departamento)
      p.text-gray Manual do usuário · Parte 1 · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  entrar no OS-m Admin
        |  e
        strong  escolher o departamento
        |  de trabalho. O login não é feito dentro do Admin: após a tela de
        |  boas-vindas você é enviado ao portal de autenticação (SSO) e, em seguida,
        |  seleciona o departamento.

      h5.h5 1. Tela de boas-vindas
      p Ao abrir o endereço do OS-m Admin, surge a tela de boas-vindas.
      figure.manual-figure
        img(:src="imgWelcome" alt="Tela de boas-vindas")
      ol
        li Clique em
          strong  Continuar
          | .
        li Você será redirecionado ao portal de autenticação (SSO).

      h5.h5 2. Autenticação (Senha Web)
      p Na tela
        strong  Autenticação
        | :
      figure.manual-figure
        img(:src="imgAuth" alt="Tela de autenticação")
      ol
        li Informe o
          strong  CPF/CNPJ
          | .
        li Informe a
          strong  Senha
          | .
        li Clique em
          strong  Entrar
          | .
      p Alternativas disponíveis (conforme habilitação da prefeitura):
      ul
        li Certificado ICP Brasil
        li gov.br
        li oxy
      p
        | Não há formulário de login dentro do próprio Admin — o acesso sempre
        | passa pelo portal de autenticação.
      .toast.toast-primary
        | Não compartilhe sua senha. Em caso de esquecimento, use
        strong  Esqueceu a senha?
        |  na tela de autenticação.

      h5.h5 3. Seleção de departamento
      p
        | Após o login com sucesso, o sistema pede que você escolha o
        strong  departamento
        |  de trabalho (os nomes variam conforme a prefeitura; exemplos: Geral,
        |  Saúde, Bem Estar Animal).
      figure.manual-figure
        img(:src="imgDepartamentos" alt="Seleção de departamento")
      ol
        li Clique na linha do departamento desejado.
        li O sistema abre a
          strong  Home
          |  desse departamento.

      h5.h5 4. Tela inicial (Home)
      p
        | Depois de selecionar o departamento, você chega à
        strong  Home
        | , com o menu lateral e os contadores de Ordens de Serviço e Documentos
        | do departamento escolhido (ex.:
        strong  Geral
        | ).
      figure.manual-figure
        img(:src="imgHome" alt="Tela inicial Home após seleção do departamento")

      h6.h6 Trocar de departamento depois
      p
        | É possível alterar o departamento a qualquer momento pelo seletor na
        strong  barra superior
        |  (exibe o nome do departamento atual, por exemplo
        strong  Geral
        | ). Toda a navegação (listas, contadores e permissões) passa a usar o
        | departamento selecionado.

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgWelcome: require("@/assets/manuais/01-welcome.png"),
      imgAuth: require("@/assets/manuais/01b-autenticacao.png"),
      imgDepartamentos: require("@/assets/manuais/02-departamentos.png"),
      imgHome: require("@/assets/manuais/03-home.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
